
import { defineComponent } from 'vue';
import { userSettingsService } from './UserSettingsService';
import Form from '@/shared/mixins/Form';
import useVuelidate from '@vuelidate/core';
import store from '@/store';
import { mapGetters } from 'vuex';

export default defineComponent({
  name: 'UserSettings',
  mixins: [Form],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      form: {
        isNotificationEnabled: false,
        adSearchLayout: null,
      },
    };
  },
  validations() {
    return {
      form: {
        isNotificationEnabled: {},
        adSearchLayout: {},
      },
    };
  },
  computed: {
    ...mapGetters(['isMobile']),
  },
  async created() {
    this.isLoading = true;
    try {
      const result = await userSettingsService.get();
      this.form = result.data;
    } catch (error) {
      console.error(error);
    }
  },
  methods: {
    onEdit() {
      this.isSuccess = false;
      this.isError = false;
    },
    async send() {
      if (!this.validate()) return;

      try {
        await userSettingsService.update(this.form);
        this.success(true);
        const result = await userSettingsService.get();
        store.dispatch('userSettingsUpdate', result.data);
      } catch (error) {
        this.handleApiError(error);
      }
    },
  },
});
